import {
  createSignalAction,
  createSimpleCreator,
} from "shared/reduxUtils"

const BASE = "REFERRAL_DASHBOARD"

export const getAllReferralsAction = createSignalAction(BASE, "GET_ALL_REFERRALS")
export const createReferralAction = createSignalAction(BASE, "CREATE_REFERRAL")
export const getReferralDetailsAction = createSignalAction(BASE, "GET_REFERRAL_DETAILS")
export const saveReferralCoverAction = createSignalAction(BASE, "SAVE_REFERRAL_COVER")
export const updateReferralStatusAction = createSignalAction(BASE, "UPDATE_REFERRAL_STATUS")
export const toggleReferralDrawerAction = createSimpleCreator(BASE, "TOGGLE_REFERRAL_DRAWER")
export const setReferralFilterQueryAction = createSimpleCreator(BASE, "SET_REFERRAL_FILTER_QUERIES")
